import React from 'react'

import ReactDOM from 'react-dom'
import { RootStateOrAny } from 'react-redux'
import { Store } from 'redux'

import { basketPromoCodeChange } from 'actions/basket'
import { promoApply, promoChange } from 'actions/promos'
import {
  setAffiliateSource,
  setAwinClickChecksum,
  setTapjoyData,
  setRoktData,
} from 'actions/tracking'
import { canUseWindow } from 'utils/browserEnvironment'
import logger from 'utils/logger'

export const SessionStorageKeys = {
  GoustoTestEmailAddressKey: 'test_email_address',
}

const isUtmSource = (source: string | string[] | null, value: string): boolean => {
  // sometime query could have several utm_source params, then it's parsed as an array
  if (Array.isArray(source)) {
    return source.map((x) => (x || '').toLowerCase()).indexOf(value) !== -1
  }

  return (source || '').toLowerCase() === value
}

export async function processQuery(
  query: Record<string, string | string[] | null>,
  store: Store<RootStateOrAny, any>,
) {
  if (!query || !store) {
    return
  }

  if (query.promo_code) {
    const promoCode = `${query.promo_code}`.toUpperCase()
    let error

    try {
      await store.dispatch(promoChange(promoCode))
    } catch (err: any) {
      error = err
      if (query.gousto_on_demand) {
        store.dispatch(basketPromoCodeChange(''))
      }

      logger.warning(`error fetching promo code ${promoCode} - ${err.message}`)
    }
    if (!error) {
      await store.dispatch(promoApply())
    }
  }

  if (query.asource) {
    store.dispatch(setAffiliateSource(query.asource))
  }

  if (query.awc) {
    store.dispatch(setAwinClickChecksum(query.awc))
  }

  if (
    (query.sid || '').toString().toLowerCase() === 'tapjoy' &&
    query.tapjoy_transaction_id &&
    query.tapjoy_publisher_id
  ) {
    store.dispatch(setTapjoyData(query.tapjoy_transaction_id, query.tapjoy_publisher_id))
  }

  if (isUtmSource(query.utm_source, 'rokt') && query.rokt_tracking_id) {
    store.dispatch(setRoktData(query.rokt_tracking_id))
  }

  if (query.axe) {
    // eslint-disable-next-line global-require, @typescript-eslint/no-var-requires
    const axe = require('@axe-core/react')
    axe(React, ReactDOM, 1000)
  }

  if (query.test_email_address && canUseWindow()) {
    window.sessionStorage.setItem(
      SessionStorageKeys.GoustoTestEmailAddressKey,
      query.test_email_address.toString(),
    )
  }
}
